"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.argsChanged = argsChanged;
exports.containsAllFields = containsAllFields;
exports.filterDataToFields = filterDataToFields;
exports.fragment = fragment;
exports.getIncludesFromQuery = getIncludesFromQuery;
exports.query = query;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _lodash = _interopRequireDefault(require("lodash"));

var _language = require("graphql/language");

var _invariant = _interopRequireDefault(require("invariant"));

var _uuid = _interopRequireDefault(require("./uuid"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context8; _forEachInstanceProperty2(_context8 = ownKeys(Object(source), true)).call(_context8, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context9; _forEachInstanceProperty2(_context9 = ownKeys(Object(source))).call(_context9, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Create `includes` array to be turned into argument for API call from given
 * query object
 * @param  {object} query
 * @return {array}
 */
function getIncludesFromQuery(query) {
  var includes = [];

  if (_lodash.default.get(query, 'args.include')) {
    var _context;

    (0, _forEach.default)(_context = query.args.include.split(',')).call(_context, function (include) {
      includes.push((0, _trim.default)(include).call(include));
    });
  }

  var related = _lodash.default.get(query.model.config, 'related', {});

  includes = (0, _concat.default)(includes).call(includes, getIncludesFromRelated(query.fields, related));
  return includes;
}
/**
 * Recursively get includes from relations
 * @param  {object} fields
 * @param  {object} related
 * @param  {string} prefix
 * @return {array}
 */


function getIncludesFromRelated(fields, related, prefix) {
  var includes = [];

  for (var fieldName in related) {
    if (_lodash.default.get(fields, fieldName)) {
      var rel = related[fieldName];

      if (rel.include) {
        var _context2;

        includes.push(prefix ? (0, _concat.default)(_context2 = "".concat(prefix, ".")).call(_context2, rel.include) : rel.include);
      }

      var model = rel.model;

      if (_lodash.default.isArray(model)) {
        model = model[0];
      }

      if (model && model.config) {
        var _context3;

        var recRelated = _lodash.default.get(model.config, 'related', {});

        includes = (0, _concat.default)(includes).call(includes, getIncludesFromRelated(fields[fieldName], recRelated, prefix ? (0, _concat.default)(_context3 = "".concat(prefix, ".")).call(_context3, rel.include) : rel.include));
      }
    }
  }

  return includes;
}
/**
 * Filter given data to match the given fields object
 * NOTE: do we really need to filter? Too much data is not really a bad
 *  thing....
 * @param  {object} data
 * @param  {object} fields
 * @return {object}
 */


function filterDataToFields() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fields = arguments.length > 1 ? arguments[1] : undefined;

  var originalData = _objectSpread({}, data); // Filter the top level


  data = _lodash.default.pickBy(data, function (value, fieldName) {
    return fields[fieldName];
  }); // Then go through the nodes that were defined as objects and filter them recursively

  var _loop = function _loop(fieldName) {
    if (data && data[fieldName]) {
      if (_lodash.default.isObject(fields[fieldName])) {
        var subData = data[fieldName].items || data[fieldName].data;

        if (subData && _lodash.default.isArray(subData)) {
          // 1:n relation
          data[fieldName] = {
            items: (0, _map.default)(subData).call(subData, function (item) {
              return filterDataToFields(item, fields[fieldName]);
            })
          };
        } else {
          data[fieldName] = filterDataToFields(data[fieldName], fields[fieldName]);
        }
      }
    }
  };

  for (var fieldName in fields) {
    _loop(fieldName);
  } // The following is just supported to be a nice little helper during development
  // Often you try to read a field that you haven't specified in your props, this
  // will wrap the data object into a proxy, which checks if the requested key is
  // part of the original data set but not part of the requested fields and console
  // warns about it if that is the case 🎉


  return _lodash.default.isObject(data) && process.env.NODE_ENV !== 'production' ? new Proxy(data, {
    get: function get(obj, key) {
      if (typeof key === 'string' && originalData[key] && !fields[key]) {
        console.warn("You're trying to access field '".concat(key, "', which is not defined in the query you ") + "used to connect to the entity. Check your 'withQuery' statement if you need to " + 'add the field to your request.');
      }

      return obj[key];
    }
  }) : data;
}
/**
 * Checks if given data object contains all given fields recursively
 * @param  {object} data
 * @param  {object} fields
 * @return {boolean}
 */


function containsAllFields(data, fields) {
  var contains = true;

  var _loop2 = function _loop2(fieldName) {
    if (!data || data[fieldName] === undefined) {
      contains = false;
    } else if (_lodash.default.isObject(fields[fieldName])) {
      if (data[fieldName] && _lodash.default.isArray(data[fieldName].items)) {
        var _context4;

        (0, _some.default)(_context4 = data[fieldName].items).call(_context4, function (item) {
          // bail out of loop when contains is false
          // to prevent overriding the contains value
          contains = containsAllFields(item, fields[fieldName]);

          if (!contains) {
            return contains;
          }
        });
      } else {
        contains = containsAllFields(data[fieldName], fields[fieldName]);
      }
    }

    if (!contains) {
      return "break";
    }
  };

  for (var fieldName in fields) {
    var _ret = _loop2(fieldName);

    if (_ret === "break") break;
  }

  return contains;
}
/**
 * Parser for graphQL like queries to the query object structure
 * @param  {TemplateStringsArray}   strings
 * @param  {class}                  model
 * @param  {Array}                  otherExpressions
 * @return {Object}
 */


function query(strings, model) {
  var _context5;

  for (var _len = arguments.length, otherExpressions = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    otherExpressions[_key - 2] = arguments[_key];
  }

  var myUuid = (0, _uuid.default)();
  var objects = {};
  var finalString = '';
  (0, _forEach.default)(strings).call(strings, function (string, i) {
    if (i === 0) {
      finalString += string + model.modelName;
    } else {
      var expression = otherExpressions[i - 1];
      var expString = parseExpression(expression);

      if (typeof expression === 'function' || (0, _typeof2.default)(expression) === 'object') {
        // If the original expression is a function, we want to keep that
        // So we store it in this object to replace it later in `parseValue`!
        objects[expString] = expression;
      }

      finalString += string + expString;
    }
  });
  var gqlAST = (0, _language.parse)(finalString);
  var names = gqlAST.definitions[0].selectionSet.selections;
  (0, _invariant.default)(names.length === 1, 'Syntax error!');
  var alias = names[0].alias ? parseValue(names[0].alias) : undefined;
  var id;
  var args = {};
  (0, _forEach.default)(_context5 = names[0].arguments).call(_context5, function (arg) {
    if (arg.name.value === 'id') {
      id = parseValue(arg.value, objects);
    } else {
      args[arg.name.value] = parseValue(arg.value, objects);
    }
  });
  var fields = parseQueryFields(names[0].selectionSet.selections);
  return {
    model: model,
    alias: alias,
    id: id,
    args: args,
    fields: fields,
    uuid: myUuid
  };
}

function parseQueryFields(selections) {
  var fields = {};
  (0, _forEach.default)(selections).call(selections, function (field) {
    var subFields = field.selectionSet;

    if (subFields) {
      fields[field.name.value] = parseQueryFields(subFields.selections);
    } else {
      fields[field.name.value] = field.alias ? field.alias.value : true;
    }
  });
  return fields;
}

function parseValue(entity, objects) {
  switch (entity.kind) {
    case 'IntValue':
      return (0, _parseInt2.default)(entity.value);

    default:
      return objects && objects[(0, _stringify.default)(entity.value)] ? objects[(0, _stringify.default)(entity.value)] : entity.value;
  }
}

function fragment(strings) {
  for (var _len2 = arguments.length, expressions = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    expressions[_key2 - 1] = arguments[_key2];
  }

  var finalString = '';
  (0, _forEach.default)(strings).call(strings, function (string, i) {
    finalString += string;
    finalString += parseExpression(expressions[i]);
  }); // Return a fragment object, that will be turned into the plain string
  // by JSON stringify

  return new QueryFragment(finalString);
}

function parseExpression(expression) {
  if (!expression) {
    return '';
  } else if (expression instanceof QueryFragment) {
    return expression.getFragment();
  } else if (typeof expression === 'function' || (0, _typeof2.default)(expression) === 'object') {
    // To properly store objects as expression value, we create a unique
    // function id string which will be replaced later on with the original function!
    return (0, _stringify.default)("$fn--".concat((0, _uuid.default)()));
  }

  return (0, _stringify.default)(expression);
}

var QueryFragment = /*#__PURE__*/function () {
  function QueryFragment(string) {
    (0, _classCallCheck2.default)(this, QueryFragment);
    this.string = string;
  }

  (0, _createClass2.default)(QueryFragment, [{
    key: "getFragment",
    value: function getFragment() {
      return this.string;
    }
  }]);
  return QueryFragment;
}();

function argsChanged(oldArgs, newArgs) {
  var _context6, _context7;

  if (oldArgs === undefined) {
    return true;
  }

  var oldKeys = (0, _filter.default)(_context6 = (0, _keys.default)(oldArgs || {})).call(_context6, function (key) {
    return key !== 'include';
  });
  var newKeys = (0, _filter.default)(_context7 = (0, _keys.default)(newArgs || {})).call(_context7, function (key) {
    return key !== 'include';
  });

  if (oldKeys.length !== newKeys.length) {
    return true;
  }

  for (var i = 0; i < oldKeys.length; i++) {
    var k = oldKeys[i];

    if (!(0, _includes.default)(newKeys).call(newKeys, k)) {
      return true;
    }

    if (oldArgs[k] !== newArgs[k]) {
      return true;
    }
  }

  if (newArgs !== null && newArgs !== void 0 && newArgs.include) {
    if (!(oldArgs !== null && oldArgs !== void 0 && oldArgs.include)) {
      return true;
    }

    var oldIncludes = oldArgs.include.split(',');
    var newIncludes = newArgs.include.split(',');

    for (var _i = 0; _i < newIncludes.length; _i++) {
      var _k = newIncludes[_i];

      if (!(0, _includes.default)(oldIncludes).call(oldIncludes, _k)) {
        return true;
      }
    }
  }
}